import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'
import { ThemeProvider } from 'styled-components'
import Highcharts from 'highcharts';
import Sunburst from 'highcharts/modules/sunburst';

import store from './reducers'
import client from './services/ApolloClient'
import { makeMainRoutes } from './routes'
import theme from './theme'

import 'bootstrap/dist/css/bootstrap.css'
import 'rc-slider/assets/index.css'
import './reset.css'

Sunburst(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    loading: 'Carregando...',
    noData: 'Nenhum registro foi encontrado',
    contextButtonTitle: 'Exportar',
    downloadJPEG: 'Exportar como JPG',
    downloadPDF: 'Exportar como PDF',
    downloadPNG: 'Exportar como PNG',
    downloadSVG: 'Exportar como SVG',
    printChart: 'Imprimir gráfico'
  }
});

const routes = makeMainRoutes()

ReactDOM.render(
  <Provider store={store()}>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        {routes}
      </ThemeProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js